import Image from "next/image";
import cn from "clsx";

import type { Partner } from "@/shared/data/partners";

import s from "./styles.module.css";

interface Props {
  partner: Partner;
  className?: string;
  /** Multiplier on the mark's tuned height. The relative sizing survives. */
  scale?: number;
}

/**
 * One partner mark. Renders the logo when we have the file, and the brand name
 * as a plain wordmark when we do not, so a partner is never silently dropped
 * from the wall while its logo is being sourced.
 */
export default function PartnerLogo({ partner, className, scale = 1 }: Props) {
  const { name, logo, height = 24 } = partner;

  if (!logo) {
    return (
      <span className={cn(s.wordmark, className)} title={name}>
        {name}
      </span>
    );
  }

  return (
    <Image
      className={cn(s.logo, className)}
      src={logo}
      alt={`${name} official logo`}
      height={Math.round(height * scale)}
    />
  );
}
